module.exports = __webpack_public_path__ + "static/media/nicotine.8835ccfe.svg";